import { useEffect, useState } from "react";

import { queryClient } from "services";

import {
  logUserAssignedToVariant,
  useFeatureFlag
} from "features/feature-flags";
import { FlattenedFlags } from "features/feature-flags/types";

const UP_NEXT_SUGGESTIONS_FLAG_ID = "up-next-suggestions";

const variants = ["control", "alwaysShow"] as const;

export type UpNextVariant = (typeof variants)[number];

export function useUpNextVariant() {
  const flag = useFeatureFlag(UP_NEXT_SUGGESTIONS_FLAG_ID);

  // TODO: uncomment when ready to release

  // const variant = variants.some(variant => variant === flag)
  //   ? (flag as UpNextVariant)
  //   : "control";
  const variant = "control" as UpNextVariant;

  const [loggedAnalytics, setLoggedAnalytics] = useState(false);
  useEffect(() => {
    if (loggedAnalytics) return;
    if (!flag) return;

    logUserAssignedToVariant({
      testId: UP_NEXT_SUGGESTIONS_FLAG_ID,
      variant: variant
    });

    setLoggedAnalytics(true);
  }, [flag, loggedAnalytics, variant]);

  return variant;
}

const UP_NEXT_SUGGESTIONS_FLAG_WITH_OVERRIDES_KEY = `${UP_NEXT_SUGGESTIONS_FLAG_ID}withOverrides`;

queryClient.setQueryDefaults([UP_NEXT_SUGGESTIONS_FLAG_WITH_OVERRIDES_KEY], {
  staleTime: Infinity,
  gcTime: Infinity
});

export function setUpNextSuggestionsFlagValue(flags: FlattenedFlags) {
  const value = flags[UP_NEXT_SUGGESTIONS_FLAG_ID];
  queryClient.setQueryData(
    [UP_NEXT_SUGGESTIONS_FLAG_WITH_OVERRIDES_KEY],
    value
  );
}

export function getUpNextSuggestionsFlagValue() {
  return queryClient.getQueryData<UpNextVariant>([
    UP_NEXT_SUGGESTIONS_FLAG_WITH_OVERRIDES_KEY
  ]);
}
